export default "/images/vendor/flag-icons/flags/4x3/cu.svg?1fc5af6daada9d6075b31137af1dc406";